/* SCRUBZ Size information: independent of variant and purchase handlers. */
(function (window, document) {
  'use strict';
  if (window.__scrubzSizeInfo) return;
  window.__scrubzSizeInfo = true;
  var active = null, panel, timer, count = 0;
  function close() {
    window.clearTimeout(timer);
    if (active) { active.setAttribute('aria-expanded', 'false'); active.dataset.scrubzTapped = ''; }
    active = null;
    if (panel) panel.hidden = true;
  }
  function position() {
    if (!active) return;
    var rect = active.getBoundingClientRect();
    panel.style.width = Math.min(320, window.innerWidth - 24) + 'px';
    var width = panel.offsetWidth, height = panel.offsetHeight;
    panel.style.left = Math.max(12, Math.min(rect.left, window.innerWidth - width - 12)) + 'px';
    var top = rect.bottom + 8;
    if (top + height > window.innerHeight - 12) top = Math.max(12, rect.top - height - 8);
    panel.style.top = top + 'px';
  }
  function open(button) {
    window.clearTimeout(timer);
    if (active && active !== button) close();
    var host = button.closest('.mfp-wrap') || document.body;
    if (panel.parentElement !== host) host.appendChild(panel);
    active = button;
    button.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    var guide = panel.querySelector('[data-scrubz-info-guide]');
    guide.hidden = false;
    panel.querySelector('[data-scrubz-info-no-guide]').hidden = !guide.hidden;
    position();
  }
  function initialize() {
    panel = document.createElement('div');
    panel.id = 'scrubz-size-info-popover';
    panel.className = 'scrubz-size-info__popover';
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Sizing may differ');
    panel.innerHTML = '<strong>Sizing may differ</strong><p>Our sizes follow American (US) sizing standards but may fit differently. Please check the size guide before placing your order to ensure the best fit.</p><a href="#" data-scrubz-info-guide>Find my size</a><span data-scrubz-info-no-guide hidden>Size guide is not configured for this product.</span>';
    document.body.appendChild(panel);
    function enhance() {
      if (active && !active.isConnected) close();
      document.querySelectorAll('.swatch .swatch__title').forEach(function (title) {
        var swatch = title.closest('.swatch');
        var name = (swatch && swatch.getAttribute('data-opname') || '').toLowerCase();
        var selected = title.querySelector('.nt_name_current');
        if (!selected) return;
        var label = '';
        for (var node = title.firstChild; node && node !== selected; node = node.nextSibling) label += node.textContent || '';
        label = label.split(':')[0].trim().toLowerCase();
        // Match the Size option and its qualifiers, including Shopify's handleized name.
        var sizeName = /^(?:sizes?|größe|grosse|große|taille)(?:$|\s|\(|-)/;
        if (swatch && (swatch.classList.contains('is-color') || swatch.classList.contains('is-ntcolor'))) return;
        if (!sizeName.test(name) && !sizeName.test(label)) return;
        title.classList.add('scrubz-size-info__title');
        if (title.querySelector('.scrubz-size-info__trigger')) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'scrubz-size-info__trigger';
        button.id = 'scrubz-size-info-trigger-' + (++count);
        button.textContent = 'i';
        button.setAttribute('aria-label', 'Size information');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-haspopup', 'true');
        selected.insertAdjacentElement('afterend', button);
      });
    }
    enhance();
    new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.scrubz-size-info__trigger');
      if (button) {
        event.preventDefault(); event.stopPropagation();
        // Focus opens first on desktop; the first click must keep it open.
        if (active === button && button.dataset.scrubzTapped === 'true') { button.dataset.scrubzTapped = ''; close(); }
        else { button.dataset.scrubzTapped = 'true'; open(button); }
        return;
      }
      if (event.target.closest('[data-scrubz-info-guide]')) {
        event.preventDefault(); event.stopPropagation();
        var trigger = active, link = panel.querySelector('[data-scrubz-info-guide]');
        if (trigger && window.ScrubzSizeGuide) {
          window.clearTimeout(timer);
          window.ScrubzSizeGuide.open(link, trigger);
        }
        return;
      }
      if (!panel.contains(event.target)) close();
    }, true);
    document.addEventListener('mouseover', function (event) {
      var button = event.target.closest('.scrubz-size-info__trigger');
      if (button) open(button);
      else if (panel.contains(event.target)) window.clearTimeout(timer);
    });
    document.addEventListener('mouseout', function (event) {
      if (event.target.closest('.scrubz-size-info__trigger') || panel.contains(event.target)) {
        if (!panel.contains(event.relatedTarget) && !(active && active.contains(event.relatedTarget))) timer = window.setTimeout(function () { if (!panel.contains(document.activeElement) && document.activeElement !== active) close(); }, 200);
      }
    });
    document.addEventListener('focusin', function (event) {
      if (event.target.matches('.scrubz-size-info__trigger')) open(event.target);
      else if (!panel.contains(event.target)) close();
    });
    document.addEventListener('keydown', function (event) {
      if (!active) return;
      if (event.key === 'Escape') { event.preventDefault(); var trigger = active; trigger.focus(); close(); }
      else if (event.key === 'Tab' && event.target === active && !event.shiftKey) {
        var link = panel.querySelector('[data-scrubz-info-guide]');
        if (!link.hidden) { event.preventDefault(); link.focus(); }
      }
    });
    window.addEventListener('resize', position);
    window.addEventListener('scroll', position, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})(window, document);
